export default "__VITE_ASSET__BLnkIJCT__"